import "../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeProps as _mergeProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("header__topnavcontainer-3eovab", {
  zIndex: 250,
  position: "relative",
  display: "none",
  ".top-bar &": {
    display: "block",
    "@media (max-width: 767px)": {
      display: "none"
    }
  },
  "@media (max-width: 767px)": {
    display: "none"
  }
});
const _staticStyles2 = _cssRef("header__groupedheadercontainer-1ue5ef", {
  position: "sticky",
  top: "0",
  zIndex: 100,
  transition: "box-shadow 0.2s",
  ".scrolled &": {
    boxShadow: "0 -2px 12px 0 --box-shadow"
  }
});
const _staticStyles3 = _cssRef("header__desktopheader-07kha0", {
  "@media (max-width: 767px)": {
    display: "none"
  }
});
const _staticStyles4 = _cssRef("header__mobileheader-3t84h5", {
  display: "none",
  "@media (max-width: 767px)": {
    display: "block"
  }
});
import React from 'react';
import { Helmet } from 'react-helmet-async';
// eslint-disable-next-line import/no-unresolved
import { useLocation } from '@reach/router';
import SidebarHeader from './sidebar-header';
import SidebarMobileAccordion from './sidebar-mobile-accordion';
import SidebarTopNav from './sidebar-top-nav';
import { breakpoints } from '../primitives/tokens';
import { useTemplateProvider } from '../../contexts/template-provider';
import { useMicrosite } from '../../contexts/franchise/microsite-context';
import { NavigationProvider, useNavigationContext } from '../../contexts/navigation-context';
import useSiteNavigation from './use-site-navigation';
const styles = {
  topNavContainer: _staticStyles,
  groupedHeaderContainer: _staticStyles2,
  desktopHeader: _staticStyles3,
  mobileHeader: _staticStyles4
};
const HeaderInner = (): JSX.Element => {
  const {
    template
  } = useTemplateProvider();
  const {
    isMicrosite,
    franchise
  } = useMicrosite();
  const mobileNavKey = franchise?.franchiseNumber ?? 'national';
  const {
    closeAllNavigation
  } = useNavigationContext();
  const siteNav = useSiteNavigation();
  const location = useLocation();
  const showTopNav = !isMicrosite || (siteNav?.secondary ?? []).some(section => Boolean(section?.title?.trim()));

  // Close all navigation when the route changes
  React.useEffect(() => {
    closeAllNavigation();
  }, [location.pathname, closeAllNavigation]);
  const classes = [template, 'top-bar', isMicrosite ? 'is-microsite' : 'is-std'].filter(x => !!x).join(' ');
  return <>
            {/* NOTE: it appears that both className and class are required for the Helmet component to work */}
            <Helmet htmlAttributes={{
      className: classes,
      class: classes
    }} />
            {showTopNav && <div {..._mergeProps({
      css: styles.topNavContainer
    })}>
                    <SidebarTopNav />
                </div>}
            <div {..._mergeProps({
      css: styles.groupedHeaderContainer
    })}>
                <div {..._mergeProps({
        css: styles.desktopHeader,
        "data-sidebar-primary-chrome": true
      })}>
                    <SidebarHeader />
                </div>
                <div {..._mergeProps({
        css: styles.mobileHeader
      })}>
                    <SidebarMobileAccordion key={mobileNavKey} />
                </div>
            </div>
        </>;
};
const Header = (): JSX.Element => <NavigationProvider>
        <HeaderInner />
    </NavigationProvider>;
export default Header;